import { Slider } from '@material-ui/core'
import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const StyledSlider = styled(Slider)`
  && {
    color: ${colors.green};
    height: 8px;
  }
  & .MuiSlider-colorPrimary {}
  & .MuiSlider-root {
    color: ${colors.green};
    height: 8px;
  }

  & .MuiSlider-mark {
    border: 2px solid white;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${colors.blue};
  }

  & .MuiSlider-thumb {
    height: 24px;
    width: 24px;
    background-color: ${colors.blue};
    border: 2px solid white;
    margin-top: -8px;
    margin-left: -12px;
    &:focus, &:hover, &$active: {
      box-shadow: inherit;
    },
  }
  & .MuiSlider-valueLabel {
    left: calc(-50% + 4px);
  }
  & .MuiSlider-track {
    height: 8px;
    border-radius: 4px;
  }
  & .MuiSlider-rail {
    height: 8px;
    border-radius: 4px;
  }

`

interface IContainer {
  valueLabelDisplay?: 'on' | 'auto' | 'off'
}

export const Container = styled.div<IContainer>`
  width: 100%;
  height: ${({ valueLabelDisplay }) =>
    valueLabelDisplay !== 'off' ? '100px' : 'auto'};

  display: flex;
  align-items: flex-end;
  justify-content: center;
`
